// Dev-only override for data-issue detection. Set to a UID to view another
// user's flagged sessions (the Bugs button + Bugs page) as if they were yours --
// handy for testing accounts with known problems since your own data may be
// clean. Leave "" for normal behavior; never ship non-empty.

// eslint-disable-next-line
const known_issues = [
  "6gGIsyw3NfhV5MKvjTWuKYgIvO72", // FOXHOUND
  "ouE49E8NDLRqkKW1kFmThWJQlBs1", // Uncutmy4skin
  "J54m79LQ52ecv3g4y8sUSSgxcbf2", // YaCantStopMe
  "l0d82T3P6dMqtZM4XWuE2UuAvKG2", // haligonian
  "TrJoVdtyZPY657q5W4zCMQRgIbq2", // TurtleneckMe
  "rHW35U5SZ5YCxl195dMpXqeS5r42", // That1Guy
  "D049ZFABAHZ4sGz7X8USRhQeDbB3", // curiouscub
  "NaFNN7xzrAZ03p2Ioyw7QCumOLx1", // SmokeyMcPot
  "7BoSFqH0jgYdaJfaer5yVLamXmq2", // Danie
  "T4z3qhXaUFRmVVQszYKboEEp7vE3", // RainbowxLZRO
  "4lAMMQQBcWVJ0GiJU4RO0dBv58H2", // Heavensentprophet
  "RfFsQFE7rZOReyWuWilFZ0Zs7oD2", // danielvamu
  "TCVHypZB9vVR1crKItfbOin6pgg2", // adamskub
  "s6XVtq4coFdWgPvP9Bo5krfiXvn2", // Cut2Intact
  "q1qwaR4FtwhEsWRMgiAC3jvQNZu2", // MoreSkin426
  "8A5SFfS9RvPYQd2Ggg613JmpvV23", // TuggingTyger
  "J54m79LQ52ecv3g4y8sUSSgxcbf2", // YaCantStopMe
];

export const DEBUG_MOCK_UID = "";
